/**
 * الأرقام العربية (٠-٩) والفارسية (۰-۹) تُكتب بالإنجليزية (0-9) — لوحة المفاتيح العربية
 * تُخرجها هكذا، والنظام يخزّن ويبحث ويطابق الهواتف والأرقام بالإنجليزية حصراً.
 */
const EASTERN = /[٠-٩۰-۹]/
const EASTERN_ALL = /[٠-٩۰-۹]/g

export function toLatinDigits(s: string): string
export function toLatinDigits(s: string | null | undefined): string | null | undefined
export function toLatinDigits(s: string | null | undefined) {
  if (!s || !EASTERN.test(s)) return s
  return s.replace(EASTERN_ALL, (d) => String(d.charCodeAt(0) - (d >= '۰' ? 0x06f0 : 0x0660)))
}

// حقول لا يُمسّ ما يُكتب فيها: كلمة المرور تُطابَق حرفياً، والبقية ليست نصاً
const SKIP_TYPES = new Set([
  'password',
  'number',
  'hidden',
  'file',
  'checkbox',
  'radio',
  'range',
  'color',
  'date',
  'datetime-local',
  'month',
  'time',
  'week',
  'submit',
  'button',
  'reset',
  'image',
])

const nativeValueSetter = (el: HTMLInputElement | HTMLTextAreaElement) =>
  Object.getOwnPropertyDescriptor(
    el instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype,
    'value',
  )!.set!

function onInput(e: Event) {
  const el = e.target
  if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement)) return
  if (el instanceof HTMLInputElement && SKIP_TYPES.has(el.type)) return
  if ((e as InputEvent).isComposing) return
  const value = el.value
  if (!EASTERN.test(value) || el.closest('[data-keep-digits]')) return

  let start: number | null = null
  let end: number | null = null
  try {
    start = el.selectionStart
    end = el.selectionEnd
  } catch {
    // email وأمثاله لا تكشف موضع المؤشر
  }
  // المُعيّن الأصلي لا مُعيّن العنصر: React يتتبّع القيمة عبر الأخير، فيرى القيمة المحوَّلة
  // «تغييراً» ويمرّرها لـ onChange بدل أن يبتلع ضغطة المستخدم
  nativeValueSetter(el).call(el, toLatinDigits(value))
  // التحويل حرفٌ بحرف — المؤشر يبقى مكانه
  if (start !== null && end !== null) {
    try {
      el.setSelectionRange(start, end)
    } catch {
      /* لا تحديد لهذا النوع */
    }
  }
}

/**
 * مستمعٌ واحد للنظام كله (مرحلة الالتقاط على الوثيقة — قبل React وantd): كل ما يُكتب أو
 * يُلصق في أي حقل نصي — هاتف، بحث، مبلغ، ملاحظة — تتحوّل أرقامه العربية لإنجليزية لحظتها.
 * حقلٌ يلزم أرقامه كما هي يُعلَّم بـ data-keep-digits (عليه أو على حاويه).
 */
export function installLatinDigitsInput(root: Document = document): () => void {
  root.addEventListener('input', onInput, true)
  return () => root.removeEventListener('input', onInput, true)
}
